/** The channel a contact was last talked to on (a message either way, or a call), among the
 * channels they have an identifier for — from the omni-contact's per-channel communicationHistory.
 * Null when there's no usable history. */
export function getLastCommunicationChannel(
  parentContact: { communicationHistory?: Array<{ channel?: string; lastMessageAt?: string | Date | null }> } | null | undefined,
  availableChannels: string[],
): string | null {
  const channels = new Set(availableChannels);
  let latest: { channel: string; at: number } | null = null;
  for (const entry of parentContact?.communicationHistory || []) {
    const at = new Date(entry?.lastMessageAt || 0).getTime();
    if (!entry?.channel || !channels.has(entry.channel) || !at) continue;
    if (!latest || at > latest.at) latest = { channel: entry.channel, at };
  }
  return latest?.channel || null;
}
